import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { spaceApi } from '../services/api';
import { usePlatformEvents } from '../contexts/PlatformEventContext';

export function useIntegrationSubscriptions(spaceId: string | undefined) {
  return useQuery({
    queryKey: ['space', spaceId, 'integration-subscriptions'],
    queryFn: () => spaceApi(spaceId!).integrations.listSubscriptions(),
    enabled: !!spaceId,
  });
}

export function useIntegrationSubscription(
  spaceId: string | undefined,
  integrationId: string | undefined,
) {
  return useQuery({
    queryKey: ['space', spaceId, 'integration-subscriptions', integrationId],
    queryFn: () => spaceApi(spaceId!).integrations.getSubscription(integrationId!),
    enabled: !!spaceId && !!integrationId,
  });
}

export function useSubscriptionLiveUpdate(
  spaceId: string | undefined,
  integrationId: string | undefined,
) {
  const queryClient = useQueryClient();
  const { subscribe } = usePlatformEvents();

  useEffect(() => {
    if (!spaceId || !integrationId) return;
    return subscribe(
      [{ source: 'optr.conn.integrations' }],
      (event) => {
        if (event.data?.integrationId !== integrationId) return;
        queryClient.invalidateQueries({
          queryKey: ['space', spaceId, 'integration-subscriptions', integrationId],
        });
      },
    );
  }, [spaceId, integrationId, subscribe, queryClient]);
}
